import { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import axios from 'axios'

// Components
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { Button } from '../../components/Button/Button'
import { SubscriptionCard } from '../../components/SubscriptionCard/SubscriptionCard'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'
import Modal from '../../components/Modal/Modal'

// Svg
import { Logo } from '../../assets'

// Styles
import './subscription.scss'

// Items
import { whatYouGet } from './items'
import { subscriptions } from './subscriptions'

// Hooks
import { useLocalStorage } from '../../hooks/useLocalStorage'
// import { useConfig } from '../../hooks/useConfig'

// Utils
import { isAccessTokenAboutToExpire, TokensType } from '../../utils/saveTokens'
import { developmentUrl } from '../../utils/developmentUrl'

export const SubscriptionScreen = () => {
  // let navigate = useNavigate()
  // const [config] = useConfig()
  const [subscriptionPlanId, setSubscriptionPlanId] = useState('')
  const [show, setShow] = useState<boolean>(false)
  const [chargebeeSubscribeUrl, setChargebeeSubscribeUrl] = useState<string | null>(null)
  const [sessionStorageToken] = useLocalStorage<TokensType | null>('sessionStorage.tokens', null)

  const onHandleSubmit = async () => {
    if (sessionStorageToken?.accessToken && subscriptionPlanId) {
      const url = `payments/checkout?planId=${subscriptionPlanId}`

      // const instance = axios.create({
      //   baseURL: config.baseURL,
      //   headers: {
      //     'Content-Type': 'application/json;charset=UTF-8',
      //     'X-ACCESS-TOKEN': sessionStorageToken.accessToken,
      //   },
      // })

      // instance.interceptors.response.use(
      //   (response) => {
      //     return response
      //   },
      //   (error) => {
      //     console.log(error, 'error')
      //     // if (error.response.status === 302) {
      //     //   console.log(error.response, 'response')
      //     // }
      //   }
      // )

      // await instance
      //   .get(url)
      //   .then((test) => {
      //     console.log(test, 'tedst')
      //   })
      //   .catch((error) => {
      //     console.log(error, 'error')
      //   })

      await axios
        .get(developmentUrl(url), {
          headers: { 'X-ACCESS-TOKEN': sessionStorageToken.accessToken },
          validateStatus: function (status) {
            return status >= 200 && status <= 302
          },
          maxRedirects: 0,
        })
        .then((response) => {
          console.log(response, 'response')
          if (response.status === 302) {
            if (response?.data?.location) {
              setChargebeeSubscribeUrl(response?.data?.location)
              console.log(response.data.location, 'response')
              setShow(true)
            }
          }
        })
        .catch((error) => {
          console.log(error.message, 'error')
        })
    }
  }

  useEffect(() => {
    if (!!sessionStorageToken) {
      isAccessTokenAboutToExpire(sessionStorageToken)
    }
  }, [sessionStorageToken])

  const onHandleSubscribe = async (subscription: any) => {
    if (subscriptionPlanId !== subscription.chargebeePlanId) {
      setSubscriptionPlanId(subscription.chargebeePlanId)
    }
  }

  return (
    <div className="subscriptions-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div className="subscription-logo">
            <Logo />
          </div>
          <section>
            <h3 className="subscription-main-title">All Access Membership</h3>
            <p className="subscription-main-description">Unlock the entire world of Presence inspiration</p>
            <Rectangle>
              <h5 className="secondary-title">
                Awesome! You have a free membership trial. Please choose a plan for after it ends:
              </h5>

              <div className="subscription-buttons">
                {subscriptions.map((subscription) => (
                  <SubscriptionCard
                    key={subscription.id}
                    type={subscription.type}
                    name={subscription.name}
                    price={subscription.price}
                    duration={subscription.duration}
                    onHandleSelectSubscription={() => onHandleSubscribe(subscription)}
                    isActive={subscription.chargebeePlanId !== subscriptionPlanId}
                  />
                ))}
              </div>

              <p className="promo-code-text">Enter your promo code on the next step</p>

              <Button onClick={onHandleSubmit}>next</Button>

              <p className="info">Don’t have your Promo code on hand?</p>
            </Rectangle>

            <Rectangle>
              <h5 className="secondary-title">What you get</h5>

              {whatYouGet.map((item) => (
                <div className="what-you-get-grid" key={item.id}>
                  <div>{item.icon}</div>
                  <div>
                    <h6 className="what-you-get-grid__title">{item.title}</h6>
                    <p className="what-you-get-grid__description">{item.description}</p>
                  </div>
                </div>
              ))}
            </Rectangle>

            <div className="terms-and-privacy">
              <p className="terms-and-privacy__cancel">Recurring billing. Cancel anytime</p>
              <div className="terms-and-privacy__buttons">
                {/* <a href="#!">Restore Purchases</a>
                <span>•</span> */}
                <a href="https://discoverpresence.co/pages/terms" target="_blank">
                  Terms
                </a>
                <span>•</span>
                <a href="https://discoverpresence.co/pages/privacy-policy" target="_blank">
                  Privacy Policy
                </a>
              </div>
              <p className="terms-and-privacy__description">
                The subscription will automatically renew unless auto-renew is turned off at least 24 hours before the
                end of the current period. Your account will be charged for renewal within 24-hours prior to the end of
                the current period. You can go to your iTunes Account Settings to manage your subscription and turn off
                auto-renew. Your iTunes Account will be charged when the purchase is confirmed. Unused portion of free
                trial is forfeited agter purchase.
              </p>
            </div>
          </section>
        </div>
      </AnimatedScreenWrapper>
      <Modal onClose={() => setShow(false)} show={show} id="subscription_modal">
        {chargebeeSubscribeUrl && <iframe height="500px" src={chargebeeSubscribeUrl} />}
      </Modal>
    </div>
  )
}
